// extracted by mini-css-extract-plugin
export default {"fill":"SearchIcon_fill__9F77S"};